import Request from '@/plugins/request';

export function getGoods(params) {
  return Request.get('goods', {
    params
  })
}

export function createGood() {
  return Request.get(`goods/create`)
}

export function storeGood(data) {
  return Request.post('goods', data)
}

export function updateGood(id, data) {
  return Request.put(`goods/${id}`, data)
}

export function updateGoodStatus(id) {
  return Request.put(`goods/${id}/status`)
}

export function changeStoreCount(data) {
  return Request.post(`goods/change-store-count`, data)
}

export function editGood(id) {
  return Request.get(`goods/${id}/edit`)
}

export function destroyGood(id) {
  return Request.delete(`goods/${id}`)
}

export function goodsSaleStats(params) {
  return Request.get('goods/goods-sale-stats', {
    params
  })
}


